import React, { useEffect, useState } from "react";
import axios from "../../../api/axios.js";
import { getFetchOptions } from "../../../js/utility.js";
import Breadcrumb from "../../utils/Breadcrumb.jsx";

const DetailClass = () => {
  const [classYear, setClassYear] = useState(null);
  const [section, setSection] = useState(null);
  const currentMonth = new Date().getMonth();
  const [schoolYear, setSchoolYear] = useState(
    currentMonth >= 8
      ? `${new Date().getFullYear()}${new Date().getFullYear() + 1}`
      : `${new Date().getFullYear() - 1}${new Date().getFullYear()}`
  );
  const [schoolId, setSchoolId] = useState(null);
  const [schools, setSchools] = useState("");

  const [classStudents, setClassStudents] = useState([]);
  const [classTeachers, setClassTeachers] = useState([]);
  const classId = window.location.pathname.split("/").pop();

  const userRole = localStorage.getItem("role");

  const breadcrumb = {
    current_section: "Nuovo",
    sections: [
      { name: "Scuole", route_name: null, params: [] },
      { name: "Gestione classi", route_name: null, params: [] },
      { name: "Nuovo", route_name: null, params: [] },
    ],
  };

  useEffect(() => {
    const fetchSchools = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/scuola`,
          fetchOptions
        );
        const result = await response.json();
        setSchools(result.return.scuola);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchClass = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/scuola/classe?idclasse=${classId}`,
          fetchOptions
        );
        const result = await response.json();
        setClassYear(result.return.classe[0].classe);
        setSection(result.return.classe[0].sezione);
        setSchoolYear(result.return.classe[0].annoscolastico);
        setSchoolId(result.return.classe[0].idscuola);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchStudents = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getAllStudents?classId=${classId}&schoolYear=${schoolYear}`,
          fetchOptions
        );
        const result = await response.json();
        if (result.error) {
          setClassStudents([]);
          return;
        }

        setClassStudents(result);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchTeachers = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getClassTeachers?classId=${classId}`,
          fetchOptions
        );
        const result = await response.json();
        if (result.error) {
          console.error("Error fetching teachers:", result.message);
          return;
        }
        setClassTeachers(result);
      } catch (error) {
        console.error("Error fetching teachers:", error);
      }
    };

    fetchSchools();
    fetchClass();
    fetchStudents();
    fetchTeachers();
  }, []);

  return (
    <div className="container-fluid">
      {/* Breadcrumb */}
      <Breadcrumb breadcrumb={breadcrumb} />
      <a href="/classes">
        <button className="btn btn-primary mb-4">
          <i className="bi bi-arrow-left"></i> Torna alla lista classi
        </button>
      </a>

      {/* General Data */}
      <div className="card custom-card">
        <div className="card-header card-title">
          <span>
            Nuovo -{" "}
            {Array.isArray(schools)
              ? schools.find((school) => school.id === schoolId)
                  ?.denomistituto || ""
              : ""}
          </span>
        </div>
        <div className="card-body">
          <form id="classForm">
            <div className="row mb-1">
              <div className="col-12 col-lg-4">
                <label htmlFor="classe">Classe</label>
                <input
                  className="form-control"
                  id="classe"
                  name="classe"
                  label="classe"
                  value={classYear || ""}
                  min={1}
                  max={5}
                  onChange={(e) => setClassYear(e.target.value)}
                  disabled
                />
              </div>

              <div className="col-12 col-lg-4">
                <label htmlFor="sezione">Sezione</label>
                <input
                  className="form-control"
                  id="sezione"
                  name="sezione"
                  label="sezione"
                  value={section || ""}
                  onChange={(e) => setSection(e.target.value)}
                  disabled
                />
              </div>

              <div className="col-12 col-lg-4">
                <label htmlFor="schoolYear">Anno scolastico</label>
                <select
                  className="form-control"
                  id="annoscolastico"
                  name="annoscolastico"
                  value={
                    schoolYear ||
                    `${new Date().getFullYear()}${new Date().getFullYear() + 1}`
                  }
                  disabled
                  onChange={(e) => setSchoolYear(e.target.value)}
                >
                  <option value="">Scegli anno scolastico...</option>
                  {Array.from({ length: 10 }).map((_, idx) => {
                    const year = new Date().getFullYear() - 5 + idx;
                    const option = (
                      <option key={year} value={`${year}${year + 1}`}>
                        {`${year}/${year + 1}`}
                      </option>
                    );
                    return option;
                  })}
                </select>
              </div>
            </div>
          </form>
        </div>
      </div>
      {/* Modular Data */}
      <div className="card custom-card">
        <div className="card-header card-title">
          <span>Dati correlati</span>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <label>
                  {" "}
                  <b>Insegnanti</b>
                </label>
                <div
                  className="d-flex"
                  style={{
                    visibility: userRole === "Admin" ? "visible" : "hidden",
                  }}
                >
                  <button
                    className={`btn btn-primary`}
                    onClick={() => {
                      window.location.href = `/teachers/add?schoolId=${schoolId}`;
                    }}
                    disabled={userRole !== "Admin"}
                  >
                    <i className="bi bi-plus"></i>
                  </button>
                </div>
              </div>

              <div className="tableContainer mt-3">
                <table className="teachersTable table table-bordered">
                  <thead>
                    <tr>
                      <th>Nominativo</th>
                      <th>Materia</th>
                    </tr>
                  </thead>
                  <tbody>
                    {classTeachers?.map((teacher) => (
                      <tr key={teacher.idinsegnante}>
                        <td>{teacher.Teacher?.nominativo}</td>
                        <td>{teacher.Subject?.materia}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <label>
                  {" "}
                  <b>Studenti</b>
                </label>
                <div className="d-flex">
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      window.location.href = `/students/add?schoolId=${schoolId}&classId=${classId}`;
                    }}
                  >
                    <i className="bi bi-plus"></i>
                  </button>
                </div>
              </div>
              <div className="tableContainer mt-3">
                <table className="studentsTable table table-bordered">
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>Cognome</th>
                    </tr>
                  </thead>
                  <tbody>
                    {classStudents?.map((student) => (
                      <tr key={student.idstudente}>
                        <td>{student.nome}</td>
                        <td>{student.cognome}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailClass;
